export class CollectionResponse<T> {
    items: T[];
    nextPageToken?: string;
}
